import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../mock';
import { useLanguage } from '../LanguageContext';

const WhatsAppButton = ({ className = '' }) => {
  const { language } = useLanguage();
  
  const handleWhatsAppClick = () => {
    const message = language === 'ar'
      ? encodeURIComponent('مرحباً، أود معرفة المزيد عن برامج هارفست لاستشارات التعليم لطفلي.')
      : encodeURIComponent('Hello, I would like to learn more about Harvest Education Consulting programs for my child.');
    window.open(`https://wa.me/${contactInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <Button 
      onClick={handleWhatsAppClick}
      variant="whatsapp"
      className={className}
    >
      <MessageCircle size={20} />
      {language === 'ar' ? 'راسلنا على واتساب' : 'Message Us on WhatsApp'}
    </Button>
  );
};

export default WhatsAppButton;
